import {
    THROW_ERROR,
    CLEAR_ERROR
} from '../constants/error.js';

export const initialState = {
    error: null,
    errorMessage: ''
};

export function errorReducer( state = initialState, action ) {

    switch ( action.type ) {

        case THROW_ERROR:

            return Object.assign( {}, state, {
                error: action.error,
                errorMessage: action.errorMessage
            });

        case CLEAR_ERROR:

            return Object.assign( {}, state, {
                error: null,
                errorMessage: ''
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/error.js